import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import CreateExpenseReportOptionsList from '../Forms/CreateExpenseReportOptionsList';
import { CREATE_EXPENSE_REPORT_OPTIONS_DEFAULT } from '../../utils/config';
import { getExpenseReportCreationOptions, getExpenseReportCreationViewModel } from '../../utils/api';
import { CreateExpenseReportContext } from '../../../../views/CreateExpenseReport/utils/CreateExpenseReportContext';
import { CREATE_EXPENSE_REPORT_OPTIONS } from '../../../../views/CreateExpenseReport/utils/constants';
import useLoadingOverlay from '../../../../hooks/useLoadingOverlay';
function Step1() {
    // TODO: if we are coming from wallet, we need to show the options from wallet, otherwise show the default options
    const { setExpenseReportCreationViewModel, setStepNumber, setSelectedOptionValue, setExpenseReportCreationOptions, setSkippedToBlankReport } = useContext(CreateExpenseReportContext);
    const { applyLoadingState, removeLoadingState } = useLoadingOverlay();
    useEffect(() => {
        (async () => {
            applyLoadingState();
            const urlParams = new URLSearchParams(window.location.search);
            const expenseReportCreationViewModel = await getExpenseReportCreationViewModel();
            const skipToBlankReport = urlParams.get('skipToBlankReport') === 'true' ||
                expenseReportCreationViewModel.TotalExpenseAndReceiptCount === 0;
            setExpenseReportCreationViewModel(expenseReportCreationViewModel);
            setSkippedToBlankReport(skipToBlankReport);
            if (skipToBlankReport) {
                const requestedExpenseReportCreationOptions = await getExpenseReportCreationOptions();
                setExpenseReportCreationOptions(requestedExpenseReportCreationOptions);
                setSelectedOptionValue(CREATE_EXPENSE_REPORT_OPTIONS.BLANK);
                setStepNumber(2);
            }
            removeLoadingState();
        })();
    }, [
        applyLoadingState,
        removeLoadingState,
        setExpenseReportCreationOptions,
        setExpenseReportCreationViewModel,
        setSelectedOptionValue,
        setSkippedToBlankReport,
        setStepNumber
    ]);
    return _jsx(CreateExpenseReportOptionsList, { options: CREATE_EXPENSE_REPORT_OPTIONS_DEFAULT });
}
export default Step1;
